"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var validate_js_1 = require("validate.js");
function findErrors(json_data, rules) {
    var r = validate_js_1.validate(json_data, rules);
    if (!r) {
        return { isValid: true, errors: {} };
    }
    var r2 = __assign({}, r);
    for (var key in r2) {
        r2[key] = r2[key][0];
    }
    return { isValid: false, errors: r2 };
}
exports.findErrors = findErrors;
function findErrorsInChecbox(array, customRule) {
    var _a;
    if (!array || array.length <= 0 || !customRule) {
        return { isValid: true, errors: {} };
    }
    var filteredValues = array.filter(function (_a) {
        var checked = _a.checked;
        return checked === true;
    });
    if (filteredValues.length <= 0) {
        return { isValid: false, errors: (_a = {}, _a[customRule] = customRule + " is required", _a) };
    }
    return { isValid: true, errors: {} };
}
exports.findErrorsInChecbox = findErrorsInChecbox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZEVycm9ycy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL2xpYi9mdW5jdGlvbnMvZmluZEVycm9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQW9DO0FBRXBDLFNBQWdCLFVBQVUsQ0FDdEIsU0FBUyxFQUNULEtBQUs7SUFFTCxJQUFJLENBQUMsR0FBRyxzQkFBUSxDQUFDLFNBQVMsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUVsQyxJQUFJLENBQUMsQ0FBQyxFQUFFO1FBQ0osT0FBTyxFQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBQyxDQUFBO0tBQ3JDO0lBQ0QsSUFBSSxFQUFFLGdCQUFPLENBQUMsQ0FBQyxDQUFBO0lBQ2YsS0FBSyxJQUFJLEdBQUcsSUFBSSxFQUFFLEVBQUU7UUFDaEIsRUFBRSxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtLQUN2QjtJQUNELE9BQU8sRUFBQyxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sRUFBRSxFQUFFLEVBQUMsQ0FBQTtBQUN2QyxDQUFDO0FBZEQsZ0NBY0M7QUFFRCxTQUFnQixtQkFBbUIsQ0FBQyxLQUFZLEVBQUUsVUFBa0I7O0lBQ2hFLElBQUksQ0FBQyxLQUFLLElBQUksS0FBSyxDQUFDLE1BQU0sSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEVBQUU7UUFDNUMsT0FBTyxFQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLEVBQUUsRUFBQyxDQUFBO0tBQ3JDO0lBQ0QsSUFBTSxjQUFjLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQyxVQUFDLEVBQVM7WUFBUixvQkFBTztRQUFNLE9BQUEsT0FBTyxLQUFLLElBQUk7SUFBaEIsQ0FBZ0IsQ0FBQyxDQUFBO0lBQ3BFLElBQUksY0FBYyxDQUFDLE1BQU0sSUFBSSxDQUFDLEVBQUU7UUFDNUIsT0FBTyxFQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxZQUFHLEdBQUMsVUFBVSxJQUFNLFVBQVUsaUJBQWMsS0FBQyxFQUFDLENBQUE7S0FDL0U7SUFDRCxPQUFPLEVBQUMsT0FBTyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsRUFBRSxFQUFDLENBQUE7QUFDdEMsQ0FBQztBQVRELGtEQVNDIn0=